import { createSelector, defaultMemoize } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const haveNextIndex = (current, length) => current !== -1 && current + 1 <= length;
const getNextIndex = (current, length) => (haveNextIndex(current, length) ? current + 1 : -1);

const memoizedNextEpisode = defaultMemoize((id, entities) => {
  if (!entities.vodEpisodes || !entities.vodSeasons || !entities.vodContent) {
    return undefined;
  }

  const currentEpisode = entities.vodEpisodes[id];

  if (!currentEpisode) {
    return undefined;
  }

  const { episodes } = entities.vodSeasons[currentEpisode.seassonId];

  const currentEpisodeIndex = episodes.indexOf(id);
  const nextEpisodeIndex = getNextIndex(currentEpisodeIndex, episodes.length);

  const nextEpisodeId = episodes[nextEpisodeIndex];
  return nextEpisodeId && entities.vodContent[nextEpisodeId];
});

const nextEpisodeSelector = createSelector([propertiesSelector], ({ entities }) => (id) =>
  memoizedNextEpisode(id, entities),
);

export const vodContentNextEpisodeSelector = subselect(nextEpisodeSelector);
